import React, { useState } from "react";
import { HelpCircle, X } from "lucide-react";

/**
 * Lightweight contextual "How this works" help. Plain-language What / Why / How,
 * with an optional "Show me how" CTA. Same premium aesthetic for all users;
 * adapt depth via props, not tone.
 */
export default function HelpPopover({ what, why, how, onShowMe, label = "How this works", testid = "help-popover" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button data-testid={`${testid}-btn`} onClick={() => setOpen(true)}
        className="text-[11px] font-mono px-2.5 py-1 rounded-lg border border-white/10 text-tc-sub hover:text-tc-coach hover:border-tc-coach/30 transition-colors inline-flex items-center gap-1.5">
        <HelpCircle className="w-3.5 h-3.5" /> {label}
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={() => setOpen(false)} data-testid={testid}>
          <div className="tc-card p-6 max-w-md w-full space-y-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <div className="text-xs font-mono uppercase tracking-widest text-tc-coach flex items-center gap-1.5"><HelpCircle className="w-4 h-4" /> {label}</div>
              <button onClick={() => setOpen(false)} className="text-tc-muted hover:text-tc-txt"><X className="w-4 h-4" /></button>
            </div>
            <Item label="What is this?" text={what} />
            <Item label="Why does this matter?" text={why} />
            <Item label="How to use it" text={how} />
            {onShowMe && (
              <button data-testid={`${testid}-showme`} onClick={() => { setOpen(false); onShowMe(); }}
                className="w-full rounded-lg bg-tc-coach text-tc-bg font-semibold py-2.5 hover:bg-tc-coach/90 transition-colors">
                Show me how
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

function Item({ label, text }) {
  if (!text) return null;
  return (
    <div>
      <div className="text-[10px] font-mono uppercase tracking-widest text-tc-mastery">{label}</div>
      <p className="text-sm text-tc-sub mt-1">{text}</p>
    </div>
  );
}
